import { Button, Modal } from "antd";
import { ReactNode, useState } from "react";
import { STATUS_REQUESTED } from "../../../constants/constants";
import CloseIcon from "../../../components/icons/CloseIcon";

interface Props {
    open: boolean;
    onCancel: () => void;
    onOk: () => void;
    content: ReactNode
    okText?: string;
    title?: string;
    cancelText?: string;
    danger?: boolean
}
const ConfirmModal = (props: Props) => {
    const { open, content, okText, title = "Alert" } = props;

    const [submitLoading, setSubmitLoading] = useState(false);
    const onOk = () => {
        props.onOk()
    }
    return (
        <Modal
            width={400}
            open={open}
            onCancel={() => props?.onCancel()}
            onOk={() => onOk()}
            classNames={{
                content: "!p-0",
                header: "!px-[20px] !pt-[16px] !pb-[10px] !my-0",
                body: "!p-[20px]",
                footer: "!px-[20px] !py-[12px] !mt-0",

            }}
            title={(
                <div className="flex items-center justify-between">
                    <p className="m-0 font-[500] text-[13px]">
                    {title}
                </p>
                    <Button type="text" icon={<CloseIcon />} className="leading-[12px]" onClick={() => props?.onCancel()}/>
                </div>
            )}
            okText={okText || `Ok`}
            okButtonProps={{
                danger: props?.danger,
                loading: submitLoading
            }}
            cancelButtonProps={{
                type: 'text',
                className: "text-[#667085]"
            }}
            closeIcon={false}
        >
            {content}
        </Modal>
    )
}

export default ConfirmModal